import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import liftupImage from '../../images/contact-liftup-1.jpg';

import styles from './styles/SidebarLiftup.module.scss';

const SidebarLiftup: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <aside className={styles.sidebarLiftup}>
      <h3 className="h2"> {t('customerService:contactLiftUp.title')} </h3>
      <img src={liftupImage} alt="" />

      <p>{t('customerService:contactLiftUp.p1')}</p>
      <p>
        {t('customerService:contactLiftUp.p2_1')}
        <Link to={`${t('customerService:contactLiftUp.p2_link1_internalurl')}`}>{t('customerService:contactLiftUp.p2_link1_txt')}</Link>
      </p>
      <p>
        {t('customerService:contactLiftUp.p2_2')}
        <Link to={`${t('customerService:contactLiftUp.p2_link2_internalurl')}`}>{t('customerService:contactLiftUp.p2_link2_txt')}</Link>
        {t('customerService:contactLiftUp.p2_3')}
      </p>
    </aside>
  );
};

export default SidebarLiftup;
